<template>
  <NotificationComponent
    v-show="visible"
    :title="title"
    @close="handleCloseTruckNotification"
  >
    <div
      v-if="truck"
      class="flex flex-col gap-2 text-left"
    >
      <div class="flex flex-col gap-1 text-left">
        <p class="text-sm text-steel-1100">
          Truck: {{ truck?.carrier_vehicle?.id }}
        </p>
        <p class="text-sm font-normal text-steel-800">
          VIN: {{ truck?.carrier_vehicle?.vehicle?.vin }}
        </p>
        <p class="text-sm font-normal text-steel-800">
          {{ truck?.carrier_vehicle?.vehicle?.model_year }}
          {{ truck?.carrier_vehicle?.vehicle?.make }}
          {{ truck?.carrier_vehicle?.vehicle?.model }}
        </p>
      </div>

      <router-link
        v-if="isLoadBoardView"
        :to="{
          name: 'Capacity',
        }"
        class="ml-2 text-sun-700 underline"
        @click="handleCloseTruckNotification"
      >
        Back to capacity
      </router-link>

      <span
        v-else
        class="cursor-pointer text-sun-700 underline"
        @click="handleRetry"
        >Post another</span
      >
    </div>
    <div
      v-else-if="errorMessage?.length > 0"
      class="text-left"
    >
      <p class="mb-2 text-sm font-normal text-steel-800">
        The following issues occured:
      </p>
      <p
        v-for="(error, errorIndex) in errorMessage"
        :key="errorIndex"
        class="text-sm font-normal text-steel-700"
      >
        {{ error }}
      </p>

      <span
        class="ml-auto mr-2 flex w-max cursor-pointer text-sm text-sun-700 underline"
        @click="handleRetry"
        >Retry</span
      >
    </div>
  </NotificationComponent>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { useStore } from 'vuex';
import { NotificationComponent } from '@/components';
import { capitalizeWords } from '@/utils/loadBoardUtils.js';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Success',
  },
  truck: {
    type: Object,
  },
  isLoadBoardView: {
    type: Boolean,
    default: false,
  },
  toggleModal: {
    type: Function,
  },
});

const store = useStore();

const truckPostingError = computed(
  () => store.state.loads?.truck_posting_error
);

const errorMessage = computed(() => {
  return Object.entries(truckPostingError?.value)?.map(([key, value]) => {
    if (!Array.isArray(value)) {
      return '';
    }

    let title;

    if (key === 'origin_area_id') {
      title = 'Origin';
    } else if (key === 'destination_area_id') {
      title = 'Destination';
    } else if (key === 'carrier_vehicle') {
      title = 'Vehicle';
    } else {
      title = capitalizeWords(key?.replace(/_/g, ' '));
    }

    let values = '';
    values = value?.reduce((acc, el, index) => {
      if (index > 0) {
        acc += ` and ${el}`;
      } else {
        acc += el;
      }

      return acc;
    }, '');

    return `${title}: ${values}`;
  });
});

const showTruckNotication = ref(false);

const handleCloseTruckNotification = () => {
  store.dispatch('toast/clearToasts');
  showTruckNotication.value = false;
};

const handleRetry = () => {
  handleCloseTruckNotification();

  props.toggleModal();
};
</script>
